import { useState } from 'react';

import { config } from 'app/config';
import { AudioPlayer } from '../audio-player/audio-player';
import { Content } from './sound-player.styled';

export const SoundPlayer = ({ row }) => {
  const ended = row.disposition === 'ANSWERED';
  const [show, setShow] = useState(false);
  if (!ended) {
    return null;
  }

  const togglePlayer = () => {
    setShow((val) => !val);
  };

  const closePlayer = () => {
    setShow(false);
  };

  const url = config.network.calls_files_url + row.id + '.mp3';
  const cl = show ? 'active' : '';
  return (
    <Content className={cl}>
      {/* <img onClick={togglePlayer} src={'/images/play.svg'} alt="play" title="Прослушать" /> */}
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" onClick={togglePlayer} title="Прослушать">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.5 16.5v-9l7 4.5z"></path>
      </svg>
      <a target="_blank" rel="noopener noreferrer" download href={url} title="Скачать">
        {/* <img src="/images/download.svg" alt="download" /> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"></path>
        </svg>
      </a>
      {show && <AudioPlayer close={closePlayer} file={url} />}
    </Content>
  );
};
